<template>
  <div>
    <el-dialog
      title="店舗切り替え"
      :visible.sync="isShown"
      v-loading="isLoading"
      :modal-append-to-body="false">
      <div class="shop">
        <ul>
          <li @click="setShop(null)">{{ groupName }}</li>
          <li
            v-for="shop in shops"
            @click="setShop(shop.pk)"
            :key="shop.pk">
            {{ shop.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ShopSelectDialog',
  data () {
    return {
      isShown: false,
      isLoading: false,
      shops: [],
    }
  },
  computed: {
    ...mapGetters('account', [
      'shopName',
      'groupName',
    ]),
  },
  methods: {
    ...mapActions('account', [
      'setAsShop',
      'resetAsShop',
    ]),
    show () {
      this.fetchData()
      this.isShown = true
    },
    fetchData () {
      this.isLoading = true
      this.$request.shops.list().then(res => {
        this.shops = res.body.results
      }).finally(() => {
        this.isLoading = false
      })
    },
    setShop (pk) {
      if (pk === null) {
        this.resetAsShop()
      } else {
        this.setAsShop(pk)
      }
      this.isShown = false
    },
  },
}
</script>

<style scoped>

.shop {
}

.shop ul {
  padding: 0;
}

.shop ul li {
  border: solid 1px;
  box-sizing: border-box;
  padding: 6px 10px;
  font-size: 12px;
  display: block;
  min-width: 300px;
  text-align: center;
  color: #555;
  cursor: pointer;
}

.shop ul li:first-child {
  border-radius: 5px 5px 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/ShopSelectDialog.vue